import React from 'react';
import Select from 'react-select';
import classnames from 'classnames';

import InputLabel from './InputLabel';

export type SelectOptionValue = string | number | Record<string, string | number | boolean | null | undefined>;

export interface SelectOption {
  label: string;
  value: SelectOptionValue;
}

interface Props {
  label?: string;
  isMandatory?: boolean;
  name: string;
  error?: React.ReactNode;
  placeholder?: string;
  value?: SelectOptionValue;
  options: SelectOption[];
  handleChange: (event: { target: { name: string; value: SelectOptionValue | null } }) => void;
  handleInputChange?: (newValue: string) => void;
  noOptionsMessage?: (obj: { inputValue: string }) => React.ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  isClearable?: boolean;
  uniqueIdentifier?: string;
  iconComponent?: (option: SelectOption) => React.ReactNode;
}

const FormSelect: React.FC<Props> = (props) => {
  const {
    label,
    isMandatory,
    name,
    error,
    placeholder,
    value,
    options,
    handleChange,
    handleInputChange,
    noOptionsMessage,
    isLoading,
    disabled,
    isClearable,
    uniqueIdentifier,
    iconComponent,
  } = props;

  const selectedOption =
    value != null
      ? (options.find((option) =>
          uniqueIdentifier
            ? (option.value as Record<string, unknown>)[uniqueIdentifier] ===
              (value as Record<string, unknown>)[uniqueIdentifier]
            : option.value === value
        ) ?? null)
      : null;

  return (
    <div className="form-group">
      {label && InputLabel(label, isMandatory)}
      <Select<SelectOption>
        options={options}
        name={name}
        className={classnames('', { 'child-border-red': error })}
        value={selectedOption}
        isDisabled={disabled}
        isClearable={isClearable}
        onChange={(selected) => handleChange({ target: { name, value: selected ? selected.value : null } })}
        placeholder={placeholder}
        onInputChange={handleInputChange}
        isLoading={isLoading}
        noOptionsMessage={noOptionsMessage}
        formatOptionLabel={iconComponent}
      />
      {error && <span className="error-block">{error}</span>}
    </div>
  );
};

export default FormSelect;
